export interface AdvanceEmiOption {
    totalTenure: number;
    advanceEmiCount: number;
}

export class AdvanceEmiPlan {
    public _id: string;
    public requestedAmount: number;
    public advanceEmiOption: AdvanceEmiOption;
    public readonly loanApplicationId: string;

    constructor(requestedAmount?: number, advanceEmiOption?: AdvanceEmiOption, loanApplicationId?: string) {
        this.requestedAmount = requestedAmount;
        this.advanceEmiOption = advanceEmiOption;
        this.loanApplicationId = loanApplicationId;
    }

    public static from(json: any): AdvanceEmiPlan {
        if (!json) {
            return json;
        }
        const advanceEmiPlan = new AdvanceEmiPlan();
        Object.assign(advanceEmiPlan, json);
        return advanceEmiPlan;
    }
}
